require("jquery-validation");

jQuery.validator.setDefaults({
    errorElement: "span",
    errorClass: "help-block",
    highlight: function(element /* errorClass, validClass */) {
        $(element)
            .closest(".form-group")
            .addClass("has-error");
    },
    unhighlight: function(element /* errorClass, validClass */) {
        $(element)
            .closest(".form-group")
            .removeClass("has-error");
    },
    errorPlacement: function(error, element) {
        if (element.prop("type") === "checkbox" || element.prop("type") === "radio") {
            error.insertBefore(element.parent());
        } else if (element.parent(".input-group").length) {
            error.insertAfter(element.parent());
        } else {
            error.insertAfter(element);
        }
    }
});
